import { render, staticRenderFns } from "./GoogleMapMarker.vue?vue&type=template&id=48789345"
import script from "./GoogleMapMarker.vue?vue&type=script&lang=js"
export * from "./GoogleMapMarker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports